export default __webpack_public_path__ + "static/media/loc_ico.b1fcbd79.svg";